import echarts from "echarts";
const install = function(Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get() {
        return {
          home_chart1: function(id) {
            console.log(id);
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            let optionData = {
              color: ["#88c925"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              grid: {
                left: "20",
                right: "20",
                bottom: "20",
                top: "20",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10",
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "20",
                    "21",
                    "22",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "40"
                  ],
                  axisTick: {
                    alignWithLabel: true
                  }
                }
              ],
              yAxis: [
                {
                  type: "value",
                  axisLabel: {
                    formatter: "{value} k"
                  }
                }
              ],
              series: [
                {
                  name: "购电统计",
                  type: "bar",
                  barWidth: "60%",
                  data: [
                    10,
                    52,
                    200,
                    74,
                    30,
                    30,
                    20,
                    10,
                    52,
                    200,
                    334,
                    390,
                    330,
                    220,
                    10,
                    52,
                    200,
                    34,
                    90,
                    30,
                    220,
                    10,
                    52,
                    200,
                    34,
                    390,
                    330,
                    220,
                    21,
                    2
                  ]
                }
              ]
            };
            this.chart.setOption(optionData, true);
            let _this = this;
            window.addEventListener("resize", function() {
              _this.chart.resize();
            });
          },
          home_chart2: function(id) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            let optionData = {
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c} ({d}%)"
              },

              grid: {
                left: "20",
                right: "20",
                bottom: "20",
                top: "20",
                containLabel: true
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  radius: "75%",
                  center: ["50%", "50%"],
                  data: [
                    { value: 335, name: "直接访问" },
                    { value: 310, name: "邮件营销" },
                    { value: 234, name: "联盟广告" },
                    { value: 135, name: "视频广告" },
                    { value: 1548, name: "搜索引擎" }
                  ],
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                  }
                }
              ]
            };
            this.chart.setOption(optionData, true);
            let _this = this;
            window.addEventListener("resize", function() {
              _this.chart.resize();
            });
          },
          home_chart3: function(id) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();

            let optionData = {
              grid: {
                left: "20",
                right: "20",
                bottom: "20",
                top: "20",
                containLabel: true
              },
              xAxis: {
                type: "category",
                data: [
                  "1月",
                  "2月",
                  "3月",
                  "4月",
                  "5月",
                  "6月",
                  "7月",
                  "8月",
                  "9月",
                  "10月",
                  "11月",
                  "12月"
                ]
              },
              yAxis: {
                type: "value"
              },
              series: [
                {
                  data: [
                    820,
                    932,
                    901,
                    934,
                    1290,
                    1330,
                    1320,
                    456,
                    232,
                    229,
                    789,
                    1000
                  ],
                  type: "line"
                }
              ]
            };

            this.chart.setOption(optionData);
            let _this = this;
            window.addEventListener("resize", function() {
              _this.chart.resize();
            });
          },
          home_chart4: function(id) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();

            let optionData = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              legend: {
                data: [
                  "直接访问",
                  "邮件营销",
                  "联盟广告",
                  "视频广告",
                  "搜索引擎",
                  "百度",
                  "谷歌",
                  "必应",
                  "其他"
                ]
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
                }
              ],
              yAxis: [
                {
                  type: "value"
                }
              ],
              series: [
                {
                  name: "直接访问",
                  type: "bar",
                  data: [320, 332, 301, 334, 390, 330, 320]
                },
                {
                  name: "邮件营销",
                  type: "bar",
                  stack: "广告",
                  data: [120, 132, 101, 134, 90, 230, 210]
                },
                {
                  name: "联盟广告",
                  type: "bar",
                  stack: "广告",
                  data: [220, 182, 191, 234, 290, 330, 310]
                },
                {
                  name: "视频广告",
                  type: "bar",
                  stack: "广告",
                  data: [150, 232, 201, 154, 190, 330, 410]
                },
                {
                  name: "搜索引擎",
                  type: "bar",
                  data: [862, 1018, 964, 1026, 1679, 1600, 1570],
                  markLine: {
                    lineStyle: {
                      type: "dashed"
                    },
                    data: [[{ type: "min" }, { type: "max" }]]
                  }
                },
                {
                  name: "百度",
                  type: "bar",
                  barWidth: 5,
                  stack: "搜索引擎",
                  data: [620, 732, 701, 734, 1090, 1130, 1120]
                },
                {
                  name: "谷歌",
                  type: "bar",
                  stack: "搜索引擎",
                  data: [120, 132, 101, 134, 290, 230, 220]
                },
                {
                  name: "必应",
                  type: "bar",
                  stack: "搜索引擎",
                  data: [60, 72, 71, 74, 190, 130, 110]
                },
                {
                  name: "其他",
                  type: "bar",
                  stack: "搜索引擎",
                  data: [62, 82, 91, 84, 109, 110, 120]
                }
              ]
            };

            this.chart.setOption(optionData);
            let _this = this;
            window.addEventListener("resize", function() {
              _this.chart.resize();
            });
          },
          home_chart5: function(id) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();

            let optionData = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow"
                }
              },

              grid: {
                left: "20",
                right: "20",
                bottom: "20",
                top: "20",
                containLabel: true
              },
              xAxis: {
                type: "value",
                boundaryGap: [0, 0.01]
              },
              yAxis: {
                type: "category",
                data: ["巴西", "印尼", "美国", "印度", "中国"]
              },
              series: [
                {
                  name: "2011年",
                  type: "bar",
                  data: [18203, 23489, 29034, 104970, 131744]
                }
                // {
                //   name: "2012年",
                //   type: "bar",
                //   data: [19325, 23438, 31000, 121594, 134141]
                // }
              ]
            };

            this.chart.setOption(optionData);
            let _this = this;
            window.addEventListener("resize", function() {
              _this.chart.resize();
            });
          }
        };
      }
    }
  });
};

export default {
  install
};



// WEBPACK FOOTER //
// ./src/assets/api/myecharts.js